import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { UPLOAD_FILE_SUPPORT } from '@/shared/constants/ds-constants';
import GoogleSigninComponent from '@/entities/scrap-agent/account/google-signin/google-signin.vue';
import MultiSelect from '@/shared/multi-select/multi-select.vue';
import { AccountChannel } from '@/shared/model/collection-channel.model';

@Component({
  components: { MultiSelect, GoogleSigninComponent, DsModal, 'google-signin': GoogleSigninComponent },
})
export default class AccountGoogleDriverComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Array, required: false }) sourceCacheList!: any;
  @Prop({ type: Array, required: false }) dataSourceSetting!: any;
  @Prop({ type: Object, default: () => ({}) }) userEdit!: any;
  showModal = this.open;
  formData = {
    all: false,
    urlFile: [''],
    urlFolder: [''],
  } as any;
  acceptUploadFile = UPLOAD_FILE_SUPPORT.join(', ');
  public uploadQueueFiles = [];
  totalSelected = 0;
  selectedItems = [];
  payload: any;
  isDisable = true;

  dataSource = {};

  selectedDataTypes = [];
  options = [
    // { value: 'EVERY_THING', label: 'Everything' },
    { value: 'DOCUMENT', label: 'Document (doc, docx, odt…)' },
    { value: 'EXCEL', label: 'Excel (xls, xlsx, csv…)' },
    { value: 'PPT', label: 'Presentations (ppt, pptx…)' },
    { value: 'PDF', label: 'PDF file' },
    // { value: 'SPECIFIC_FILE', label: 'Specific file' },
    { value: 'TEXT', label: 'TXT' },
    { value: 'HTML', label: 'HTML' },
    // { value: 'IMAGE', label: 'Image' },
    // { value: 'SPECIFIC_FOLDER', label: 'Specific folder' },
    { value: 'HWP', label: 'HWP' },
  ];
  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    this.formData = {
      all: false,
      urlFile: [''],
      urlFolder: [''],
    } as any;
    this.selectedDataTypes = [];
    if (this.dataSourceSetting.length > 0 || this.sourceCacheList.length > 0) {
      console.log(this.dataSourceSetting, 'this.dataSourceSetting');
      console.log(this.sourceCacheList, 'this.sourceCacheList');
      const target = this.dataSourceSetting.find(item => item.accountId === this.userEdit.accountId && item.channelType === 'GOOGLE_DRIVE');
      console.log(target, 'target');
      if (target && Array.isArray(target.collections)) {
        target.collections.forEach(collection => {
          if (Array.isArray(collection.datasourceList)) {
            collection.datasourceList.forEach(ds => {
              if (Array.isArray(ds.dataSourceTypes) && ds.dataSourceTypes.length > 0) {
                if (ds.dataSourceTypes[0] == 'EVERY_THING') {
                  this.formData.all = true;
                  this.selectedDataTypes = [];
                } else {
                  this.selectedDataTypes.push(ds.dataSourceTypes[0]);
                }
              }
            });
          }
        });
      }
      const matchedChannel = this.sourceCacheList.find(
        channel => channel.channelType === 'GOOGLE_DRIVE' && channel.accounts?.[0]?.accountId === this.userEdit.accountId
      );

      if (matchedChannel) {
        const dataSources = matchedChannel.accounts[0].dataSource;
        dataSources.forEach(ds => {
          if (ds.dataSourceTypes[0] === 'EVERY_THING') {
            this.formData.all = true;
            this.selectedDataTypes = [];
          } else {
            this.selectedDataTypes.push(ds.dataSourceTypes[0]);
          }
        });
      }
    } else {
      this.formData = {
        all: false,
        urlFile: [''],
        urlFolder: [''],
      } as any;
    }
  }
  @Watch('formData.all')
  onSelectEveryThing(value: boolean) {
    if (value) {
      this.selectedDataTypes = [];
    }
  }
  @Watch('selectedDataTypes')
  onSelectedDataTypes(value: any) {
    this.isDisable = value.length < 1 && !this.formData.all;
  }
  addUrlFolder() {
    this.formData.urlFolder.push('');
  }
  addUrlFile() {
    this.formData.urlFile.push('');
  }
  handleDataType() {
    /*TODO: fix payload google drive*/
    const isEverythingSelected =
      this.formData.all ||
      this.selectedDataTypes.some(m => {
        const type = typeof m === 'object' && m.value ? m.value : m;
        return type === 'EVERY_THING';
      });

    if (isEverythingSelected) {
      return ['EVERY_THING'];
    }

    const dataSourceTypes: string[] = [];
    this.selectedDataTypes.forEach(m => {
      const type = typeof m === 'object' && m.value ? m.value : m;
      switch (type) {
        case 'DOCUMENT':
          dataSourceTypes.push('DOCUMENT');
          break;
        case 'EXCEL':
          dataSourceTypes.push('EXCEL');
          break;
        case 'PPT':
          dataSourceTypes.push('PPT');
          break;
        case 'PDF':
          dataSourceTypes.push('PDF');
          break;
        case 'TEXT':
          dataSourceTypes.push('TEXT');
          break;
        case 'HTML':
          dataSourceTypes.push('HTML');
          break;
        case 'SPECIFIC_FILE':
          dataSourceTypes.push('SPECIFIC_FILE');
          break;
        case 'IMAGE':
          dataSourceTypes.push('IMAGE');
          break;
        case 'SPECIFIC_FOLDER':
          dataSourceTypes.push('SPECIFIC_FOLDER');
          break;
        case 'HWP':
          dataSourceTypes.push('HWP');
          break;
        default:
          break;
      }
    });
    return dataSourceTypes;
  }

  async handleSignInSuccess(data: any, info: any) {
    const types = this.handleDataType();

    const newDataSources = types.map(type => {
      if (type === 'EVERY_THING') {
        return { dataSourceTypes: [type], descriptionEn: 'Everything', dataSourceAccStatus: 1, value: null };
      }
      if (type === 'SPECIFIC_FILE') {
        return { dataSourceTypes: [type], value: this.formData.urlFile };
      }
      if (type === 'SPECIFIC_FOLDER') {
        return { dataSourceTypes: [type], value: this.formData.urlFolder };
      }
      if (type === 'TEXT') {
        return { dataSourceTypes: [type], descriptionEn: 'TXT', value: null };
      }
      if (type === 'PPT') {
        return { dataSourceTypes: [type], descriptionEn: 'Presentations', value: null };
      }
      if (type === 'EXCEL') {
        return { dataSourceTypes: [type], descriptionEn: 'Excel', value: null };
      }
      if (type === 'DOCUMENT') {
        return { dataSourceTypes: [type], descriptionEn: 'Document', value: null };
      }
      return { dataSourceTypes: [type], value: null };
    });

    const value = {
      channelId: null,
      channelName: 'Google Drive',
      channelDescription: this.formData.channelName || '',
      channelImageUri: 'https://upload.wikimedia.org/wikipedia/commons/d/da/Google_Drive_logo.png',
      channelType: 'GOOGLE_DRIVE',
      allowAccess: 'true',
      accounts: [
        {
          accountId: this.userEdit.accountId,
          accountName: this.userEdit.accountName || '-',
          dataSource: newDataSources,
          password: this.userEdit.authorizationCode,
          isScrap: true,
        },
      ],
    };
    this.handleAddDriver(value);
  }

  handleAddDriver(value) {
    const accountIds = this.dataSourceSetting
      .filter(item => item.channelType === 'GOOGLE_DRIVE' && item.accountId)
      .map(item => item.accountId);
    if (accountIds.includes(this.userEdit.accountId)) {
      this.$emit('addItemGoogleDrive', value, true);
    } else {
      this.$emit('addItemGoogleDrive', value, false);
    }
  }
  handleModalClose() {
    this.$emit('modal:close');
    this.formData = {
      all: false,
      urlFile: [''],
      urlFolder: [''],
    } as any;
    this.selectedDataTypes = [];
  }

  handleAccessToken(payload, inf) {
    console.log(payload, inf, 'data');
    this.payload = payload;
    this.handleSignInSuccess(payload, inf).then(r => {});
    this.$emit('modal:ok');
    this.formData = {
      all: false,
      urlFile: [''],
      urlFolder: [''],
    } as any;
    this.selectedDataTypes = [];
  }
}
